// extracted by mini-css-extract-plugin
export var products_video_height = "manager-module--products_video_height--136c7";